(() => {
  const VISIBLE_CLASS = 'sa-floating-atc--visible';

  function getHeaderHeight() {
    const header = document.querySelector('.header-wrapper');
    return header ? header.getBoundingClientRect().height : 0;
  }

  function initFloatingAtc(button) {
    const sectionId = button.getAttribute('data-section-id');
    const productFormId = button.getAttribute('data-product-form-id');
    const originalAtc = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const scrollTarget =
      document.getElementById(`variant-selects-${sectionId}`) ||
      (productFormId && document.getElementById(productFormId)) ||
      originalAtc;

    if (!originalAtc || !scrollTarget) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          button.classList.toggle(VISIBLE_CLASS, scrolledPast);
        });
      },
      { threshold: 0 }
    );
    observer.observe(originalAtc);

    button.addEventListener('click', () => {
      const targetTop = scrollTarget.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: targetTop - getHeaderHeight(),
        behavior: 'smooth',
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-sa-floating-atc]').forEach(initFloatingAtc);
  });
})();
